import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import AirdropCard from '@/components/AirdropCard'
import FutureFunctionDialog from '@/components/dialogs/FutureFunctionDialog'
const Airdrops = () => {
  const { t } = useTranslation()

  const [selectedFilter, setSelectedFilter] = useState<string>('all')
  const handleFilterChange = (filter: string) => {
    setSelectedFilter(filter)
  }

  const stats = [
    {
      label: t('airdrops.totalPoints'),
      value: '15,200 PTS',
      className: 'border-r w-fit px-3'
    },
    {
      label: t('airdrops.airdropsClaimed'),
      value: '4',
      className: 'border-r w-fit px-3'
    },
    {
      label: t('airdrops.airdropsPending'),
      value: '2',
      className: 'pl-3 w-fit'
    }
  ]

  const filters = [
    { id: 'all', label: t('airdrops.all') },
    { id: 'available', label: t('airdrops.available') },
    { id: 'inProgress', label: t('airdrops.inProgress') },
    { id: 'completed', label: t('airdrops.completed') }
  ]

  const airdropsData = [
    {
      id: 1,
      title: 'ZKSync',
      subtitle: 'ZKS',
      completedTasks: '1',
      totalTasks: '5',
      estReward: '$250 USD',
      buttonAction: 'join',
      status: 'available'
    },
    {
      id: 2,
      title: 'Optimism',
      subtitle: 'OP',
      completedTasks: '2',
      totalTasks: '4',
      estReward: '$150 USD',
      buttonAction: 'join',
      status: 'inProgress'
    },
    {
      id: 3,
      title: 'Arbitrum',
      subtitle: 'ARB',
      completedTasks: '5',
      totalTasks: '5',
      estReward: '$500 USD',
      buttonAction: 'claim',
      status: 'completed'
    }
  ]

  const filteredAirdrops = airdropsData.filter(
    (airdrop) => selectedFilter === 'all' || airdrop.status === selectedFilter
  )

  return (
    <div className="flex flex-col gap-8 w-full bg-card rounded-3xl p-6 mt-8 relative overflow-hidden h-[calc(100vh-150px)]">
      <div className="flex flex-col md:flex-row justify-between pl-2 md:items-center gap-6 md:gap-0">
        <h1 className="text-3xl font-bold text-text-main">
          {t('airdrops.title')}
        </h1>
        <div className="flex items-center overflow-x-auto scrollbar-hide pb-2 md:pb-0 w-full md:w-auto">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`text-xs flex flex-col gap-1 border-border-base ${stat.className}`}
            >
              <p className="text-text-secondary tracking-wide font-medium uppercase">
                {stat.label}
              </p>
              <h3 className="font-semibold text-accent">{stat.value}</h3>
            </div>
          ))}
        </div>
      </div>

      {/* BUTTON TABS */}
      <div className="flex gap-1 md:gap-4 overflow-x-auto scrollbar-hide pb-2 w-full">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => handleFilterChange(filter.id)}
            className={`whitespace-nowrap shrink-0 font-medium py-2 px-4 ${
              selectedFilter === filter.id
                ? 'text-accent border-accent shadow-xs dark:border-text-main border rounded-2xl'
                : 'text-text-secondary'
            }`}
          >
            {filter.label}
          </button>
        ))}
      </div>

      {/* Airdrop Card Container */}
      <div className="flex flex-col gap-3">
        {filteredAirdrops.map((airdrop) => (
          <AirdropCard
            key={airdrop.id}
            title={airdrop.title}
            subtitle={airdrop.subtitle}
            completedTasks={airdrop.completedTasks}
            totalTasks={airdrop.totalTasks}
            estReward={airdrop.estReward}
            buttonAction={airdrop.buttonAction}
            onActionClick={() => {}}
          />
        ))}
      </div>
      <FutureFunctionDialog
        open={true}
        preventClose
        isPageScoped
      />
    </div>
  )
}

export default Airdrops
